import { render, staticRenderFns } from "./AnimalNumbersDairySupport.vue?vue&type=template&id=366cf13e&"
import script from "./AnimalNumbersDairySupport.vue?vue&type=script&lang=js&"
export * from "./AnimalNumbersDairySupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports